
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Pginlaxmichowkhinjewadinearphase() {



    const cardData =
    {
        keyword: 'PG in Laxmi Chowk Hinjewadi Near Phase 1 & 2 ',
        heading: 'Shree Swami Samarth PG: PG in Laxmi Chowk Hinjewadi Near Phase 1 & 2',
        headingDescription: 'Shree Swami Samarth PG offers affordable and well-furnished PG in Laxmi Chowk, Hinjewadi near Phase 1 & 2, providing a convenient and homely stay for students and IT professionals. Ideally located close to major tech companies, our PG ensures hassle-free daily commuting with easy access to Infosys, Wipro, Cognizant, and other corporate offices. The rooms are spacious, clean, and fully equipped with essential amenities like high-speed WiFi, 24x7 water supply, comfortable bedding, and ample storage. Residents also enjoy hygienic home-cooked meals, CCTV surveillance, and regular housekeeping, ensuring a safe and stress-free living environment. With disciplined management, budget-friendly rent packages, and proximity to both Phase 1 and Phase 2, Shree Swami Samarth PG in Laxmi Chowk is the perfect choice for professionals and students seeking reliable, secure, and comfortable accommodation in Hinjewadi.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Strategic Location Near Phases 1 & 2",
    "description": "PGs in Laxmi Chowk, Hinjewadi, are centrally located between Phases 1 and 2, offering unmatched access to IT offices, coaching centers, and public transport. Located near major landmarks like Life Republic, Birlasoft, and The Genius School, these PGs minimize commute time and enhance daily convenience. The area is evolving rapidly into a vibrant residential and professional hub—ideal for students and working professionals alike."
  },
  {
    "title": "Variety of Room Configurations",
    "description": "Options range from budget-conscious twin-sharing rooms (as low as ₹6,000/month) to private single rooms (around ₹8,000/month), available across several well-rated PGs in Laxmi Chowk. Shared or individual layouts ensure flexibility for different lifestyle and financial preferences—making them suitable for students, IT professionals, and freelancers."
  },
  {
    "title": "Basic Comforts & Amenities",
    "description": "Most PGs offer essential facilities such as Wi-Fi, power backup, TV, and clean rooms maintained on a daily or regular basis. For example, Laxmi PG Services includes these amenities in both single and twin-sharing options. Higher-end choices may add AC, meals, and enhanced hygiene protocols—depending on your preference."
  },
  {
    "title": "Food Options Available",
    "description": "While some PGs include meals as part of the package, others keep food as an optional add-on. Listings like ‘So Ham Women PG Service’ and Kasa PG Rajgad indicate food inclusion, providing flexibility based on preferences and dietary needs. Whether you're looking for all-inclusive convenience or a self-catering setup, these PGs cater to both."
  },
  {
    "title": "Secure & Comfortable Environment",
    "description": "PGs here tend to be professionally managed and located in well-lit, monitored areas near Laxmi Chowk. Ratings show that names like Gokul PG are trusted for safety and quality. With regular housekeeping, visitor policies, and proximity to schools and offices, these PGs offer peace of mind for long-term stays."
  },
  {
    "title": "Covers All Resident Types",
    "description": "These PGs in Laxmi Chowk cater to a diverse audience—unisex, male-only, female-only, student-focused, and professional-oriented setups. Listings like Gokul PG, Seven Heaven PG, and So Ham Women PG Services reflect this inclusive profile, ensuring that you find accommodation suited to your specific needs and comfort."
  },
  {
    "title": "Transparent Pricing & Range of Choices",
    "description": "Rent structures are clear, and you’ll find twin-sharing rooms from ₹6,000/month and single rooms from ₹8,000/month at places like Laxmi PG Services. Premium coliving options, such as Bunk Haus Luxury PG, offer upscale pricing with added amenities. The transparent pricing ensures you can budget confidently while securing the right level of features."
  },
  {
    "title": "Nearby Lifestyle & Community Facilities",
    "description": "With marketplaces, schools, offices, and community hubs nearby, residents benefit from easy access to shopping, dining, banks, and recreational facilities. Laxmi Chowk’s central yet residential positioning offers both vibrancy and tranquility—making it an excellent neighborhood to live, work, and thrive in Hinjewadi."
  }
],


"services": [
  {
    "name": "PG in Laxmi Chowk Hinjewadi",
    "description": "Shree Swami Samarth PG offers well-furnished and secure PG accommodations in Laxmi Chowk, Hinjewadi. Ideal for working professionals and students, our PGs provide a comfortable living environment with essential amenities like Wi-Fi, housekeeping, and 24/7 security. Located conveniently near IT parks, shopping centers, and transport hubs, it’s the perfect choice for hassle-free living."
  },
  {
    "name": "Affordable PG Near Phase 1 and 2 Hinjewadi",
    "description": "Looking for budget-friendly PG options near Phase 1 and 2 of Hinjewadi? Shree Swami Samarth PG provides affordable accommodations without compromising on comfort or safety. Enjoy clean rooms, timely maintenance, and a friendly community environment, all close to major IT companies."
  },
  {
    "name": "PG for Working Professionals in Laxmi Chowk",
    "description": "Our PGs in Laxmi Chowk cater especially to working professionals, offering flexible rental plans, ergonomic furniture, uninterrupted power supply, and a calm atmosphere for work and relaxation. Proximity to corporate offices like Infosys and Capgemini makes commuting easy and convenient."
  },
  {
    "name": "Boys PG in Laxmi Chowk Near Infosys",
    "description": "Shree Swami Samarth PG features dedicated boys’ PG accommodations near Infosys in Laxmi Chowk. Enjoy secure rooms with shared or private options, nutritious meal plans, and reliable housekeeping services, all designed to support the lifestyle of young male professionals."
  },
  {
    "name": "Girls PG Near Capgemini Hinjewadi",
    "description": "Our girls’ PG near Capgemini in Laxmi Chowk offers a safe and nurturing environment with well-furnished rooms, security measures, and community activities. Designed to provide comfort and peace of mind, it is ideal for female working professionals and students."
  },
  {
    "name": "Shared PG in Laxmi Chowk",
    "description": "For those seeking budget-conscious living, Shree Swami Samarth PG offers shared PG accommodations in Laxmi Chowk. Shared rooms come with adequate privacy, common recreational areas, and essential amenities, making it an economical and social choice for residents."
  },
  {
    "name": "Furnished PG Near Phase 1 Hinjewadi",
    "description": "Our fully furnished PGs near Phase 1 Hinjewadi feature modern interiors, comfortable beds, storage solutions, and attached bathrooms. Perfect for individuals seeking plug-and-play living spaces close to their workplace or educational institute."
  },
  {
    "name": "Monthly PG in Laxmi Chowk",
    "description": "Shree Swami Samarth PG offers flexible monthly PG rental plans in Laxmi Chowk, allowing residents to enjoy hassle-free stays with transparent pricing. Monthly packages include utilities, Wi-Fi, security, and maintenance, providing a seamless living experience."
  }
],
"tableData": [
  ["PG in Laxmi Chowk Hinjewadi", "Affordable PG Near Phase 1 and 2"],
  ["PG for Working Professionals in Laxmi Chowk", "Boys PG in Laxmi Chowk Near Infosys"],
  ["Girls PG Near Capgemini Hinjewadi", "Shared PG in Laxmi Chowk"],
  ["Furnished PG Near Phase 1 Hinjewadi", "Monthly PG in Laxmi Chowk"]
],




"whychoose": [
    {
        "WhyChooseheading": "Convenient PG Accommodation at Laxmi Chowk, Hinjewadi",
        "WhyChoosedescription": "Shree Swami Samarth PG offers comfortable and affordable paying guest accommodations near Laxmi Chowk, strategically positioned between Hinjewadi Phase 1 and Phase 2. Ideal for working professionals and students, our PG ensures easy access to major IT hubs and essential amenities."
    },
    {
        "WhyChooseheading": "Proximity to Hinjewadi Phase 1 & 2 IT Parks",
        "WhyChoosedescription": "Located just minutes from the key IT campuses of Phase 1 and Phase 2, including Wipro, Infosys, and Cognizant, our PG drastically reduces your daily commute, allowing you more time for work and leisure."
    },
    {
        "WhyChooseheading": "Well-Furnished Rooms with Essential Amenities",
        "WhyChoosedescription": "Choose from single, double, and triple-sharing rooms, all fully furnished with beds, wardrobes, study tables, and high-speed Wi-Fi. Clean attached or common bathrooms and power backup ensure a hassle-free living experience."
    },
    {
        "WhyChooseheading": "Delicious, Hygienic Meals Included",
        "WhyChoosedescription": "Enjoy freshly prepared vegetarian and non-vegetarian meals served thrice daily. Our kitchen maintains strict hygiene standards to provide nutritious and tasty food that keeps you energized throughout your busy day."
    },
    {
        "WhyChooseheading": "Safe and Secure Environment with 24/7 Monitoring",
        "WhyChoosedescription": "Your safety is paramount. Our PG features CCTV surveillance, biometric entry, and round-the-clock security staff to ensure a secure and peaceful living space for all residents."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent with Transparent Pricing",
        "WhyChoosedescription": "Our monthly rent includes accommodation, meals, electricity, Wi-Fi, housekeeping, and laundry services, with no hidden charges or brokerage fees. Flexible lease options are available to suit your needs."
    },
    {
        "WhyChooseheading": "Supportive Staff and 24/7 Assistance",
        "WhyChoosedescription": "Our dedicated management and support team are available around the clock to assist with maintenance requests, emergencies, or any other needs, ensuring a comfortable and stress-free stay."
    },
    {
        "WhyChooseheading": "Ideal for Professionals and Students Alike",
        "WhyChoosedescription": "Whether you’re a corporate employee, an intern, or a student, Shree Swami Samarth PG offers a welcoming and comfortable environment conducive to both work and study."
    }
]
























    }
    
const faqData = [
    {
        question: "How can I book a PG in Laxmi Chowk Hinjewadi near Phase 1 & 2?",
        answer: "You can book your room by calling us at +91 9594917913. We also provide online booking and virtual tours on request."
    },
    {
        question: "What types of rooms are available at your PG in Laxmi Chowk?",
        answer: "We offer single, double, and triple sharing rooms, both A/C and non-A/C, fully furnished with modern amenities."
    },
    {
        question: "Is your PG near major IT parks in Hinjewadi Phase 1 & 2?",
        answer: "Yes, our PG is located close to major IT companies in Hinjewadi Phase 1 & 2, making your daily commute easy and quick."
    },
    {
        question: "What facilities do you provide in your PG at Laxmi Chowk?",
        answer: "Facilities include high-speed Wi-Fi, hygienic meals, 24/7 security, CCTV surveillance, power backup, laundry, and housekeeping."
    },
    {
        question: "Is food included in the PG rent?",
        answer: "Yes, we provide freshly cooked vegetarian meals three times a day as part of the rent."
    },
    {
        question: "Is the PG safe for both male and female residents?",
        answer: "Absolutely. We maintain strict security protocols including CCTV, biometric access, and dedicated male/female sections."
    },
    {
        question: "What is the monthly rent for PG rooms in Laxmi Chowk Hinjewadi?",
        answer: "Rent varies depending on the room type and facilities. Contact us directly for current pricing and offers."
    },
    {
        question: "Is there a minimum stay requirement for booking at this PG?",
        answer: "Yes, the minimum stay is generally one month. Longer stays may be eligible for discounts."
    },
    {
        question: "Are guests allowed at the PG in Laxmi Chowk?",
        answer: "Guest entry is restricted and managed carefully to ensure safety and privacy of all residents."
    },
    {
        question: "How do I contact Shree Swami Samarth PG to book a room in Laxmi Chowk, Hinjewadi?",
        answer: "You can reach us at +91 9594917913 for inquiries, visits, and bookings."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Abhishek Joshi',
        designation: 'Developer, Wipro Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“Convenient location near both Phase 1 & 2. The PG is clean, secure, and well-managed. Perfect for IT professionals.”',
    },
    {
        name: 'Ms. Aarti Kulkarni',
        designation: 'Student, Symbiosis Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“Safe and comfortable PG in Laxmi Chowk with good food and friendly staff. Ideal for students and working ladies.”',
    },
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "PG in Laxmi Chowk Hinjewadi Near Phase 1 & 2",
  "image": "https://swamisamarthpg.com/assets/images/pg-laxmi-chowk-hinjewadi.jpg", // Replace with actual image URL
  "description": "Affordable and furnished PG accommodations in Laxmi Chowk Hinjewadi near Phase 1 and 2. Suitable for working professionals with options for boys and girls PG near major IT parks.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.87",
    "ratingCount": "1800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/pg-laxmi-chowk-hinjewadi"  // Replace with actual page URL if different
  }
};







    return (
        <div>

<Helmet>
  <title>PG in Laxmi Chowk Hinjewadi Near Phase 1 & 2 | Affordable & Furnished</title>
  <meta 
    name="description" 
    content="Affordable and furnished PG in Laxmi Chowk Hinjewadi near Phase 1 and 2. Ideal for working professionals with boys and girls PG options near Infosys and Capgemini." 
  />
  <meta 
    name="keywords" 
    content="PG in Laxmi Chowk Hinjewadi, Affordable PG Near Phase 1 and 2, PG for Working Professionals in Laxmi Chowk, Boys PG in Laxmi Chowk Near Infosys, Girls PG Near Capgemini Hinjewadi, Shared PG in Laxmi Chowk, Furnished PG Near Phase 1 Hinjewadi, Monthly PG in Laxmi Chowk" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pginlaxmichowkhinjewadinearphase;